const colorsList = [
  "#003f5c",
  "#444e86",
  "#955196",
  "#dd5182",
  "#ff6e54",
  "#ffa600",
  "#B64992",
  "#49B66D",
];

const NOC_PRIMARY = "#126da1";
const NOC_SECONDARY = "#86EFAC";

module.exports = {
  colorsList,
  NOC_PRIMARY,
  NOC_SECONDARY,
};
